import { Form, Select } from "antd";
import { DefaultMultipleSelectProps } from "../../../../types/bulkEmails/CriteriaOption";
import { useCallback, useEffect, useState } from "react";

export const DefaultCriteriaMultipleValueSelect = ({
  value,
  onChange,
  options,
  formKey,
  form,
  rules
}: DefaultMultipleSelectProps) => {
  const [initialized, setInitialized] = useState(false);

  const handleChange = useCallback(
    (selectedValues: string[]) => {
      onChange(selectedValues);
    },
    [onChange]
  );

  useEffect(() => {
    if (!initialized) {
      form.setFieldValue(formKey, value);
      handleChange(value);
      setInitialized(true);
    }
  }, [form, formKey, value, initialized, handleChange]);

  return (
    <Form.Item name={formKey} className="w-100 mb-0" preserve={false} rules={rules}>
      <Select className="w-100" mode="multiple" value={value} onChange={handleChange}>
        {options.map((option) => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};
